(function () {
  var searchBtn = document.querySelector('.p-search-btn');
  var bubble = document.querySelector('.p-search-bubble');
  var input = document.querySelector('.p-search-input');
  var closeBtn = document.querySelector('.p-search-close');
  var results = document.querySelector('.p-search-results');
  var timer = null;
  var selectedIndex = -1;
  var productData = null;

  if (!searchBtn || !bubble) return;

  var overlay = document.createElement('div');
  overlay.className = 'p-search-overlay';
  document.body.appendChild(overlay);
  document.body.appendChild(bubble);

  function loadProductData() {
    if (productData) return;
    fetch('/search?section_id=p-product-json')
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var text = html.replace(/<[^>]*>/g, '').trim();
        productData = JSON.parse(text);
      });
  }

  function searchProducts(query) {
    if (!productData) return [];
    var q = query.toLowerCase();
    var scored = [];
    productData.forEach(function (p) {
      var score = 0;
      if (p.title && p.title.toLowerCase().indexOf(q) !== -1) score = 3;
      else if (p.jpName && p.jpName.toLowerCase().indexOf(q) !== -1) score = 2;
      else if (p.description && p.description.toLowerCase().indexOf(q) !== -1) score = 1;
      if (score > 0) scored.push({ product: p, score: score });
    });
    scored.sort(function (a, b) { return b.score - a.score; });
    return scored.slice(0, 5).map(function (s) { return s.product; });
  }

  function renderResults(items) {
    if (items.length === 0) {
      results.innerHTML = '<div class="p-search-empty">該当する商品が見つかりませんでした</div>';
      results.style.display = '';
      return;
    }
    results.innerHTML = items.map(function (p) {
      var html = '<a href="' + p.url + '" class="p-search-item">';
      if (p.image) {
        html += '<img class="p-search-thumb" src="' + p.image + '" alt="' + p.title + '" loading="lazy">';
      }
      html += '<div class="p-search-item-info">';
      html += '<span class="p-search-item-title">' + p.title + '</span>';
      if (p.jpName) {
        html += '<span class="p-search-item-subtitle">' + p.jpName + '</span>';
      }
      html += '<span class="p-search-item-price">&yen;' + Math.floor(p.price / 100).toLocaleString() + '</span>';
      html += '</div></a>';
      return html;
    }).join('');
    results.style.display = '';
  }

  function getItems() {
    return results.querySelectorAll('.p-search-item');
  }

  function updateSelection() {
    var items = getItems();
    items.forEach(function (item, i) {
      if (i === selectedIndex) {
        item.classList.add('is-selected');
        item.scrollIntoView({ block: 'nearest' });
      } else {
        item.classList.remove('is-selected');
      }
    });
  }

  // Preload product data
  loadProductData();

  var savedScrollY = 0;

  function preventTouch(e) { e.preventDefault(); }

  function lockScroll() {
    var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    savedScrollY = window.scrollY;
    document.documentElement.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = -savedScrollY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.paddingRight = scrollbarWidth + 'px';
    overlay.addEventListener('touchmove', preventTouch, { passive: false });
    overlay.classList.add('is-open');
  }

  function unlockScroll() {
    if (document.body.style.position !== 'fixed') return;
    document.documentElement.style.overflow = '';
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.paddingRight = '';
    overlay.removeEventListener('touchmove', preventTouch);
    window.scrollTo(0, savedScrollY);
    overlay.classList.remove('is-open');
  }

  // Toggle bubble
  searchBtn.addEventListener('click', function (e) {
    e.stopPropagation();
    var isOpen = bubble.classList.toggle('is-open');
    if (isOpen) {
      lockScroll();
      if (window.innerWidth > 600) {
        var rect = searchBtn.getBoundingClientRect();
        var cartEl = document.querySelector('#p-global-header .p-cart');
        var rightEdge = cartEl ? cartEl.getBoundingClientRect().right : rect.right;
        var bubbleRight = window.innerWidth - rightEdge;
        var btnCenter = rect.left + rect.width / 2;
        var arrowRight = rightEdge - btnCenter - 7;
        bubble.style.top = (rect.bottom + 10) + 'px';
        bubble.style.right = bubbleRight + 'px';
        bubble.style.left = '';
        bubble.style.setProperty('--arrow-right', arrowRight + 'px');
      } else {
        bubble.style.top = '';
        bubble.style.right = '';
        bubble.style.left = '';
      }
      input.value = '';
      results.innerHTML = '';
      results.style.display = 'none';
      selectedIndex = -1;
      input.focus();
      loadProductData();
    } else {
      unlockScroll();
    }
  });

  // Close on outside click
  document.addEventListener('click', function (e) {
    if (!bubble.contains(e.target) && !searchBtn.contains(e.target)) {
      bubble.classList.remove('is-open');
      unlockScroll();
    }
  });

  // Close on overlay click
  overlay.addEventListener('click', function () {
    bubble.classList.remove('is-open');
    unlockScroll();
  });

  // Close on × button click
  if (closeBtn) {
    closeBtn.addEventListener('click', function () {
      bubble.classList.remove('is-open');
      unlockScroll();
    });
  }

  // Close on ESC + keyboard navigation
  document.addEventListener('keydown', function (e) {
    if (!bubble.classList.contains('is-open')) return;

    if (e.key === 'Escape') {
      bubble.classList.remove('is-open');
      unlockScroll();
      return;
    }

    var items = getItems();
    if (items.length === 0) return;

    if (e.key === 'ArrowDown') {
      e.preventDefault();
      selectedIndex = selectedIndex < items.length - 1 ? selectedIndex + 1 : 0;
      updateSelection();
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      selectedIndex = selectedIndex > 0 ? selectedIndex - 1 : items.length - 1;
      updateSelection();
    } else if (e.key === 'Enter' && selectedIndex >= 0 && selectedIndex < items.length) {
      e.preventDefault();
      items[selectedIndex].click();
    }
  });

  // Prevent bubble click from closing
  bubble.addEventListener('click', function (e) {
    e.stopPropagation();
  });

  // Debounced client-side search
  input.addEventListener('input', function () {
    clearTimeout(timer);
    selectedIndex = -1;
    var query = input.value.trim();

    if (!query) {
      results.innerHTML = '';
      results.style.display = 'none';
      return;
    }

    timer = setTimeout(function () {
      var matched = searchProducts(query);
      renderResults(matched);
      selectedIndex = -1;
    }, 100);
  });
})();
